//**************************************************************************************************
//*************************************** MenuService FACTORY ****************************
//**************************************************************************************************

'use strict';

class MenuService{
   
    
   constructor ($timeout,$http,$q,$rootScope,$cookies,$state,CodesService,MessagingService) {
     
      this.menuList = {};
      this.menusUser = {};
      this.pageList = {};
      this.navbar = {};
      this.navbarItems = [];
      this.sidemenus = {};
      this.currentNavbarId;
      this.selectedSideMenuId;
      this.selectedApp;
      this.editMode = false;
      this.loadingMenu = false;
      this.sideMenuLarge=true;
      this.selectedNavbar = null;
      this.selectedSideMenu = null;
      this.navbarSelected = false;
      this.sideMenuSelected = false;
      this.$timeout=$timeout;
      this.$http = $http;
      this.$q=$q;
      this.$rootScope =$rootScope; 
      this.CodesService = CodesService;
      this.MessagingService = MessagingService; 
      this.$cookies = $cookies;
      this.$state = $state;
    }

   static $inject = ['$timeout', '$http','$q','$rootScope','$cookies','$state','CodesService','MessagingService'];
   
 
  /**********************************************************
	***************** GET menu editMode******************
	***********************************************************/ 
   getMenuEditMode (){
   return this.editMode;
  
 }
  /**********************************************************
	***************** GET sidemenu size******************
	***********************************************************/ 
   getSideMenuSize( ){
   return this.sideMenuLarge;
  
   } 
  /**********************************************************
	***************** Change sidemenu size******************
	***********************************************************/ 
   changeSideMenuSize (){
      this.sideMenuLarge=!this.sideMenuLarge;
  
   } 
  /**********************************************************
	***************** SET menu editMode******************
	***********************************************************/ 
   setMenuEditMode (modeValue){
      this.editMode=modeValue;
       
        this.navbarSelected = false;
        this.sideMenuSelected = false;
       
   }
 
  getSelectedNavbar(){
   return this.selectedNavbar;
  
 }
 
 /**********************************************************
	***************** GET CurentNavbarId******************
	***********************************************************/     
  
    getCurrentNavbarId (){
          
         return this.currentNavbarId;
		  };
      
	/**********************************************************
	***************** SET CurentNavbarId******************
	***********************************************************/     
  
  setCurrentNavbarId (navbarId,language){
          
         if (!this.navbarSelected || this.sideMenuSelected) this.loadingMenu=true; 
         this.currentNavbarId=navbarId;
         
         this.sideMenuSelected = false;
         this.selectedSideMenuId = null;
         if (this.currentNavbarId!=null) this.navbarSelected = true;
         
         
         var type=0;
         if (this.editMode) type=1;
         this.setCurrentNavbarObjectById(language,type);
         var self = this;
         this.$timeout(function(){
            self.loadingMenu=false;
         });
		  };

      updateNavbarSelectedSideMenu (){
         
         let i,j;    
         for (i=0;i<this.navbarItems.length;i++)
         {
               if (this.navbarItems[i].id == this.selectedSideMenu.Navbar)
               {
                  for (j=0;j<this.navbarItems[i].SideMenus.length;j++)
                  {
                     if (this.navbarItems[i].SideMenus[j].id == this.selectedSideMenuId)
                     {
                     
                        this.navbarItems[i].SideMenus[j] = this.selectedSideMenu;
                        break;
                     }
                  }
               }
         }
        
		}
      
      addNewSideMenuToNavbar(sideMenu){
         
         let i;    
         for (i=0;i<this.navbarItems.length;i++)
         {
               if (this.navbarItems[i].id == this.currntNavbarId)
               {
                  
                        this.navbarItems[i].SideMenus.push (sideMenu);
                        break;
                     
                  
               }
         }
        
		}
        
   setSelectedSidemenu (menuId){
      
      if (this.navbarSelected && !this.sideMenuSelected) this.loadingMenu=true;
      this.selectedSideMenuId=menuId;
      this.navbarSelected = false;
      if (menuId!=null) this.sideMenuSelected = true;
      else this.sideMenuSelected = false;
      this.setCurrentSideMenuObjectById();
      var self = this;
      this.$timeout(function(){
        self.loadingMenu=false;
      });
 }
 
    setSelectedApp (app){
   
     this.selectedApp=app;

    };
 
   getSelectedSidemenu (){
      return this.selectedSideMenu;
  
 }
  getLoadingMenu (){
      return this.loadingMenu;
  
 }
  
   	/**********************************************************
	***************** SAVE MENU ******************
	***********************************************************/      
    
    saveMenu (menu,language){
      
       var deferred = this.$q.defer();
       
			this.$http({
                method: 'POST',
                url: '../api/save-menu/'+language+'/',
                headers: { 'Content-Type': 'application/json' },

                data: menu,
             
            })
                .then(function (data) {

                   deferred.resolve(data.data);
                
                },function (error) {
                    
                    
                    deferred.reject(error);
                });
				
             
         
	
          return deferred.promise;
		  };
		     
         
  /**********************************************************
	***************** PROCESS MENU CLICK******************
	***********************************************************/      
    
    ProcessMenuClick (menuId){
 
    var deferred = this.$q.defer();
       
			this.$http({
                method: 'GET',
                url: '../api/process-menu-click/'+menuId+'/',
                headers: { 'Content-Type': 'application/json' },
             
            })
                .then(function (data) {

                   deferred.resolve(data.data);
                
                },function (error) {
                    
                    
                    deferred.reject(error);
                });
				
             
         
	
          return deferred.promise;
		  };
   
  
           
  /**********************************************************
	***************** SAVE MENU ORDER******************
	***********************************************************/      
    
    saveMenuOrder (language,type,appId){
      
       
       var menu;
       if (appId==undefined) appId="0";
       
       if (type==0) menu = this.navbarItems;
       else menu = this.selectedNavbar.SideMenus;
       
       var deferred = this.$q.defer();
       
			this.$http({
                method: 'POST',
                url: '../api/save-menu-order/'+language+'/',
                headers: { 'Content-Type': 'application/json' },

                data: menu,
             
            })
                .then(function (data) {

                   deferred.resolve(data.data);
                
                },function (error) {
                    
                    
                    deferred.reject(error);
                });
				
             
         
	
          return deferred.promise;
		  };
   
   	/**********************************************************
	***************** SAVE HOME PAGE******************
	***********************************************************/      
    
    saveHomePage (homePageProps){
      
      var deferred = this.$q.defer();
       
			this.$http({
                method: 'POST',
                url: '../api/save-home-page/',
                headers: { 'Content-Type': 'application/json' },

                data: homePageProps,
             
            })
                .then(function (data) {

                   deferred.resolve(data.data);
                
                },function (error) {
                    
                    
                    deferred.reject(error);
                });
				
             
         
	
          return deferred.promise;
		  };
      		  
               		  
  /**********************************************************
	***************** CLEAR MENUS *****************************
	***********************************************************/  
    Clear (){
        
        this.menuList = {};
        this.pageList = {};
        this.navbar = {};
        this.navbarItems = [];
        this.selectedNavbar=null;
        this.selectedSideMenu=null;
        this.currentNavbarId = null;
        this.selectedSideMenuId =null;
        //service = {};
        
        
               
		  };
     	/**********************************************************
	***************** GET MENUS ******************
	***********************************************************/      
    
    getMenus (language,type,refresh,appId){
       
       var instance = this;
       var deferred = this.$q.defer();
       var l_refresh = refresh;
       if (l_refresh==undefined) l_refresh = false;
       if (appId==undefined) appId = "0";
       var url =  '../api/get-menus/'+language+'/'+type+'/'+appId+'/'
       
       if (this.menuList[language+type+appId]==undefined || l_refresh){
          this.$http({
                method: 'GET',
                url: url,
                headers: { 'Content-Type': 'application/json' },

               // data: menu,
             
            })
                .then(function (data) {
                   
                   if (instance.menuList[language+type+appId]!=undefined)
                   {
                    instance.menuList[language+type+appId].length = 0;
                   }
                   instance.menuList[language+type+appId] = data.data;
                   deferred.resolve(data.data);
                
                },
                function (error) {
                    
                    
                    deferred.reject(error);
                });
				
             
         }else {
               
                deferred.resolve(this.menuList[language+type+appId], 200);
              }
	
          return deferred.promise;
		  };
  
	/**********************************************************
	***************** GET NAVBARS FROM MENU LIST ******************
	***********************************************************/  
    getNavbarsFromMenus (language,type,refresh,appId){
      
      if (appId==undefined) appId="0";
      
      if (this.navbar[language+type+appId]==undefined || refresh){
     
      var pos=-1;
      
     
       
      if (this.menuList[language+type+appId]==undefined)
      {
      
        return null;
        
      }
     
       this.navbar[language+type+appId] = [];
       this.sidemenus[language+type+appId] = [];
       
      
       for (var i=0;i<this.menuList[language+type+appId].length;i++)
       {
          if (this.menuList[language+type+appId][i].MenuPosition.id!=undefined){
          if (this.menuList[language+type+appId][i].MenuPosition.id.substr(0,6)=="navbar")
          {
                    
            pos =this.navbar[language+type+appId].map(function(e) { return e.id; }).indexOf(this.menuList[language+type+appId][i].id);
            if (pos<0) this.navbar[language+type+appId].push(this.menuList[language+type+appId][i]);
         
          
         }else if (this.menuList[language+type+appId][i].MenuPosition.id=="sidemenu")
         {
          
             pos =this.sidemenus[language+type+appId].map(function(e) { return e.id; }).indexOf(this.menuList[language+type+appId][i].id);
             if (pos<0) this.sidemenus[language+type+appId].push(this.menuList[language+type+appId][i]);
          
        
          }
           
          }
        }
      
      //get Menus
    
      
    for (var j=0;j<this.navbar[language+type+appId].length;j++)
    {
         for (var k=0;k<this.sidemenus[language+type+appId].length;k++)
       {
        if (this.navbar[language+type+appId][j].id==this.sidemenus[language+type+appId][k].Navbar)
        {
          if (this.navbar[language+type+appId][j].SideMenus ==undefined) this.navbar[language+type+appId][j].SideMenus = [];
          
          pos =this.navbar[language+type+appId][j].SideMenus.map(function(e) { return e.id; }).indexOf(this.sidemenus[language+type+appId][k].id);
          if (pos<0) this.navbar[language+type+appId][j].SideMenus.push(this.sidemenus[language+type+appId][k]);
          
        }
       }
    }
      
 }
      if (this.navbar[language+type+appId].length==0) this.navbar[language+type+appId] = null;
      return this.navbar[language+type+appId];
};

/**********************************************************
	***************** REFRESH MENUS ******************
	***********************************************************/  
   refreshMenus (language,type,appId){
    
    var deferred = this.$q.defer();
    var instance = this;
    
    this.getMenus(language,type,true,appId).then(function (data) {
              
              
            
                  var l_navbar = instance.getNavbarsFromMenus(language,type,true,appId);
                  instance.navbarItems = l_navbar;
                  deferred.resolve(l_navbar);
                                             
                         
                                                           
        });
     return deferred.promise;     
    
    };

      /**********************************************************
	***************** GET NAVBARS FROM MENU LIST ******************
	***********************************************************/  
    getNavbars (language){
      var deferred = this.$q.defer();
      var l_navbar;
      var type=0;
      var appId="0";
      if (this.selectedApp!=undefined)
      {
        appId = this.selectedApp.id;
        if (appId!="0" && appId!=undefined) type=2;
      }
      var instance = this;
      if (!this.editMode)
      {
       
        if (this.navbar[language+type+appId]==undefined || this.navbar[language+type+appId]==null)
        {
           this.getMenus(language,type,false,appId).then(function (data) {
              
             
                  l_navbar = instance.getNavbarsFromMenus(language,type,false,appId);
                  instance.navbarItems = l_navbar;
                  deferred.resolve(l_navbar);
                                            
        });
          
        }
        else
        {
            l_navbar = this.getNavbarsFromMenus(language,type,false,appId);
            this.navbarItems = l_navbar;
            deferred.resolve(l_navbar);

          
        }
      }
      else
      {
        
        type=1;
        if (this.navbar[language+type+appId]==undefined || this.navbar[language+type+appId]==null)
        {
           this.getMenus(language,type,false,appId).then(function (data) {
               
                  //if (data.status==200)                
                 // {
                  l_navbar = instance.getNavbarsFromMenus(language,type,false,appId);
                  instance.navbarItems = l_navbar;
                  deferred.resolve(l_navbar);
                 // }
                 // else
                  //{
                   //  deferred.reject();
                  //}
                                                           
                  
        });
          
        }
        else
        {
           l_navbar = this.getNavbarsFromMenus(language,type,false,appId);
           this.navbarItems = l_navbar;
           deferred.resolve(l_navbar);
          
        }
        
      }
       return deferred.promise;
    };
      /**********************************************************
	***************** SET PAGES ******************
	***********************************************************/
   SetPages() {
            var deferred = this.$q.defer();
            var instance = this;
            this.getPagesForUser(this.$rootScope.globals.currentUser.lang).then(function (data) {
                               
                                instance.$rootScope.globals.currentUser.pages=data;
                                instance.$rootScope.globals.currentUser.pagesLoaded=true;
                               
                                return deferred.resolve(true);
            });
            return deferred.promise; 
        }
 /**********************************************************
	***************** SET MENUS ******************
	***********************************************************/
   SetMenus() {
            var deferred = this.$q.defer();
            var instance = this;
            this.getMenus(this.$rootScope.globals.currentUser.lang,0).then(function (data) {
                              
                                instance.$rootScope.globals.currentUser.navBars = instance.getNavbarsFromMenus(instance.$rootScope.globals.currentUser.lang,0);
                                instance.generateChildrenNavbarRight();
                               
                                instance.$rootScope.globals.currentUser.navbarLoaded=true;
                               
                                return deferred.resolve(true);
            });
         return deferred.promise; 
        }
        
  /**********************************************************
	***************** SET MENUS ON AUTH OR PAGE LOAD ******************
	***********************************************************/
  LoadMenus (scope) {
     var deferred = this.$q.defer();
     var instance = this;
     this.SetMenus().then(function(data){
                      if (data)
                      {
                           
                            instance.SetPages().then(function(data){
                              if (data)
                              {
                                  instance.$timeout(function(){
                                       
                                        instance.$rootScope.globals.InterceptorIsActive = true;
                                  });
                                     
                                 // scope.activity.activityMessage = instance.ProcessingService.setActivityMsg(''); ovo odkomentirati kad se migrira ProcessingService ES6
                                  var lang = instance.$rootScope.globals.currentUser.lang;
                                  var stateName = 'app.navbar.home';
                                  var stateTemp = instance.$cookies.getObject('lastToState');
                                  var paramsTemp = instance.$cookies.getObject('lastToParams');
                                  var navbar=instance.getNavbarByTargetName(stateName,lang);
                                  var params = {'navbar_id':navbar};
                                  
                                  if (stateTemp!=undefined)
                                  {
                                    if (stateTemp.name!="app.login" && stateTemp.name!="app.logout" && stateTemp.name!="app.otherwise" && stateTemp.name!=undefined)
                                    {
                                      stateName=stateTemp.name;
                                      params = paramsTemp;
                                    }
                                  }
                                  
                                 
                                  instance.$state.go(stateName,params);
                                  deferred.resolve();
                                  
                              }else{ deferred.reject('LoadMenus function -> Set pages error');}
                            });
                           
                                
                      }else{ deferred.reject('LoadMenus function -> Set menus error');}
                      
    });
    return deferred.promise; 
  }
   /**********************************************************
	***************** GENERATE CHILDREN RIGHT SIDE MENU ******************
	***********************************************************/
   
  generateChildrenNavbarRight () {
  
        var parent;
        this.$rootScope.globals.currentUser.cMenus = {};
        if (this.$rootScope.globals.currentUser.navBars!=undefined && this.$rootScope.globals.currentUser.navBars!=null)
        {
            for (var i=0;i<this.$rootScope.globals.currentUser.navBars.length;i++)
            {
              parent = this.$rootScope.globals.currentUser.navBars[i].ParentItem;
              if (parent != undefined && parent != null)
              {
          
                if (this.$rootScope.globals.currentUser.cMenus[parent]==undefined){
                  this.$rootScope.globals.currentUser.cMenus[parent]=[];
                }
               
                  this.$rootScope.globals.currentUser.cMenus[parent].push(angular.copy(this.$rootScope.globals.currentUser.navBars[i]));
                
              }
            }
        }
      //return cMenus;
   };
 	
 /**********************************************************
	***************** GET MENUS FOR NAVBAR ******************
	***********************************************************/     
  
 getMenusForNavbar (navbarId,language,type,appId){
          
          var menus = [];
          if (type==undefined) type=0;
          if (appId==undefined) appId="0";
          if (navbarId != undefined) {
           
              
              if (this.navbar[language+type+appId]!=undefined){
                  for (var j=0;j<this.navbar[language+type+appId].length;j++)
                  {	  
                      if (this.navbar[language+type+appId][j].id == navbarId)
                      {
                        menus = angular.copy(this.navbar[language+type+appId][j].SideMenus);
                        break;
                      }
                  }         
              }
          }
      
      return menus;
         
		  };
   
  /**********************************************************
	***************** NEW Sidemenu ******************
	***********************************************************/
      newSideMenu (lang) {
          
          
         var order = 0;
         if (this.selectedNavbar.SideMenus!=undefined) order = this.selectedNavbar.SideMenus.length;
       
         var instance = this;
         this.CodesService.getCodesDetailObjectByName('menutypes','sidemenu',lang).then(function(data)
        
         {
            var  menu_position = data;


            instance.selectedSideMenu = {id:null,Name:'New menu item',Users:[],Groups:[],TargetPage:null,AlwaysNew:false,TargetTask:null,ParentItem:null,MenuType:1,Params: {},Order:order,MenuPosition:menu_position,Navbar:instance.currentNavbarId};
            // $scope.selectedSideMenu.Params = {pageid:}
            instance.selectedSideMenu.headerLabel="Select users/groups that will have access to this menu item";
            instance.selectedSideMenu.usersLabel="Users";
            instance.selectedSideMenu.groupsLabel="Groups";
            instance.selectedSideMenu.pageDropdownNavbar = {placeholder: 'Select page...', label:'Page',name:'pages', selectedItem:instance.selectedSideMenu.TargetPage ,
                  paddingLeft:true,hideLabel:false,sizeXs:false,dropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'};
                
            instance.selectedSideMenu.taskDropdownNavbar = {placeholder: 'Select task...', label:'Task',name:'tasks', selectedItem: instance.selectedSideMenu.TargetTask,
                  paddingLeft:true,hideLabel:false,sizeXs:false,dropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'};
              
            instance.sideMenuSelected = true;
            instance.navbarSelected = false;
         },function(error){
                                  
            instance.MessagingService.addMessage("Code name for sidemenu not found",'error');
                                
         });      
   
   }
  /**********************************************************
	***************** NEW Navbar ******************
	***********************************************************/     
    newNavbar (lang,position) {
        
       var order = 0;
       if (this.navbar[lang+'10']!=undefined) order=this.navbar[lang+'10'].length+1;
       if (position==undefined) position='navbar';
       var instance = this;
       this.currentNavbarId = 0;
       this.CodesService.getCodesDetailObjectByName('menutypes',position,lang).then(function(data)
        
        {
        var  menu_position = data;
        
        instance.selectedNavbar = {Name:'New navbar item',Users:[],Groups:[],TargetPage:null,AlwaysNew:false,TargetTask:null,MenuType:1,MenuPosition:menu_position,ParentItem:null,Params: {pageid:  null},Order:order,Navbar:null};
        instance.selectedNavbar.headerLabel="Select users/groups that will have access to instance navigation bar";
        instance.selectedNavbar.usersLabel="Users";
        instance.selectedNavbar.groupsLabel="Groups";
        instance.selectedNavbar.pageDropdownNavbar = {placeholder: 'Select page...', label:'Page',name:'pages', selectedItem:instance.selectedNavbar.TargetPage ,
                  paddingLeft:true,hideLabel:false,dropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'};
                
        instance.selectedNavbar.taskDropdownNavbar = {placeholder: 'Select task...', label:'Task',name:'tasks', selectedItem: instance.selectedNavbar.TargetTask,
                  paddingLeft:true,hideLabel:false,dropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'};
                            
        instance.selectedNavbar.menuTypeDropdownNavbar = {placeholder:'Select menu position...',label:'Menu position',name:'Menuposition',selectedItem:instance.selectedNavbar.MenuType,
                      paddingLeft:true,hideLabel:false,ropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'}; 
     
        instance.navbarSelected = true;
        instance.sideMenuSelected = false;   
        
        
         },function(error){
                                  
                                 MessagingService.addMessage("Code name for navbar not found",'error');
                                
                              });
       
   }
   
   
    /**********************************************************
	***************** SET SideMenu order ******************
	***********************************************************/  
    setSidemenuOrder (language){
     
          for (var i=0;i<this.navbar[language+'10'].length;i++)
          {	  
              if (this.navbar[language+'10'][i].id == this.currentNavbarId)
              {
                
                this.navbar[language+'10'][i].SideMenus = this.selectedNavbar.SideMenus;
                this.navbarItems[i].SideMenus = this.selectedNavbar.SideMenus;
               
              }
          }
      
      
    };
 
  
    /**********************************************************
	***************** SET SideMenu after save ******************
	***********************************************************/  
    setSidemenu (language){
     
          for (var i=0;i<this.navbar[language+'10'].length;i++)
          {	  
              if (this.navbar[language+'10'][i].id == this.currentNavbarId)
              {
                
                this.navbar[language+'10'][i].SideMenus = this.selectedNavbar.SideMenus;
                for (var j=0;j<this.selectedNavbar.SideMenus.length;j++)
                {
                  if (this.selectedNavbar.SideMenus[j].id==this.selectedSideMenu.id)
                  {
                    this.selectedNavbar.SideMenus[j] = this.selectedSideMenu;
                    
                    
                  }
                }
               
              }
          }
      
      
    };
     /**********************************************************
	***************** SET SideMenu order ******************
	***********************************************************/  
    setNavbarOrder (newNavbar,lang){
          
          this.navbar[language+'10'] = newNavbar
          
          //ovo nije dobro - treba cijeli array razbacati
          for (var j=0;j<this.navbar[language+'00'].length;j++)
          {
          
            for (var i=0;i<this.navbar[language+'10'].length;i++)
            {	  
              if (this.navbar[language+'10'][i].id == this.navbar[language+'00'][j].id)
              {
                
                this.navbar[language+'00'][j].Order = this.navbar[language+'10'][i].Order 
               
              }
            }
          
          }
             
     
         
      
      
    };
    
	/**********************************************************
	***************** GET RESOURCE DEF ID BY PAGEID ******************
	***********************************************************/     
  
 getResourceDefIdByPageId (pageid,language){
          
          if (pageid != undefined) {
           
              
              if (this.pageList[pageid+language]!=undefined){
				  

                return this.pageList[pageid+language].ResourceDefId;
             
            }else{
              return null;
            }
          }
	
         
		  };
	
           
	/**********************************************************
	***************** GET All Pages******************
	***********************************************************/     
  
 GetAllPages (){
       var pages=[];
       for (var key in this.pageList) {
         pages.push(this.pageList[key]);
       }
       
       return pages;
		  };
      
            
     getIfNavbarSelected (){
      
        return  this.navbarSelected;
    
      
      }; 

            
  getIfSideMenuSelected (){
      
        return  this.sideMenuSelected;
      
  };
	/**********************************************************
	***************** GET MENUS FOR PAGE BY NAME ******************
	***********************************************************/  
    getMenusForPageByName (pagename,language){
      
      var menus=[];
     for (var key in this.pageList) {
       
      if (this.pageList[key].Target==pagename)  menus =  this.pageList[key].Menus;
     
           
		  }
      return menus;
    };
  
 	/**********************************************************
	***************** GET PAGE By Id ******************
	***********************************************************/     
  
 getPageByResourceId (pageid,language){
      
    
      for (var key in this.pageList) {
       if (key.indexOf(language) !== -1)
       {
          if (this.pageList[key].ResourceDefId.id==pageid)  return angular.copy(this.pageList[key]);
       }
           
		  }
      return null;
      
 }
  
    /**********************************************************
	***************** SET NAVBAR BY ID ******************
	***********************************************************/  
    setCurrentNavbarObjectById (language,type){
      
     if (type==undefined) type=0;
     var appId="0";
     if (this.selectedApp!= undefined) appId=this.selectedApp.id;
     if (appId!="0" && appId!=undefined)
     {
      type=2;
     }else if (appId==undefined)
     {
      appId="0";
     }
     if (this.navbar[language+type+appId]==undefined)
      {
          this.getNavbarsFromMenus(language,type,false,appId);
      }
      
      
      this.selectedNavbar=null;
      if (this.navbar[language+type+appId]!=undefined)
      {
          for (var j=0;j<this.navbar[language+type+appId].length;j++)
          {	  
              if (this.navbar[language+type+appId][j].id == this.currentNavbarId)
              {
                
               
                this.selectedNavbar= angular.copy(this.navbar[language+type+appId][j]);
                this.selectedNavbar.headerLabel="Select users/groups that will have access to this navigation bar";
                this.selectedNavbar.usersLabel="Users";
                this.selectedNavbar.groupsLabel="Groups";
                this.selectedNavbar.pageDropdownNavbar = {placeholder: 'Select page...', label:'Page',name:'pages', selectedItem:this.selectedNavbar.TargetPage ,
                  paddingLeft:true,hideLabel:false,dropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'};
                
                this.selectedNavbar.taskDropdownNavbar = {placeholder: 'Select task...', label:'Task',name:'tasks', selectedItem: this.selectedNavbar.TargetTask,
                  paddingLeft:true,hideLabel:false,dropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'};
                            
                this.selectedNavbar.menuTypeDropdownNavbar = {placeholder:'Select menu position...',label:'Menu pos.',name:'Menupositions',selectedItem:this.selectedNavbar.MenuType,
                      paddingLeft:true,hideLabel:false,dropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'}; 
                break;
              }
          }
      }       
     
    };
     /**********************************************************
	***************** SET SIDEMENU BY ID ******************
	***********************************************************/  
    setCurrentSideMenuObjectById (){
      
     
       if (this.selectedNavbar!=undefined)
       {
          if (this.selectedNavbar.SideMenus!=undefined)
          {
            for  (var i=0;i<this.selectedNavbar.SideMenus.length;i++)
            {
          
                if  (this.selectedNavbar.SideMenus[i].id==this.selectedSideMenuId)
                {
                   this.selectedSideMenu=angular.copy(this.selectedNavbar.SideMenus[i]);
                   this.selectedSideMenu.headerLabel="Select users/groups that will have access to this menu item";
                   this.selectedSideMenu.usersLabel="Users";
                   this.selectedSideMenu.groupsLabel="Groups";
                   this.selectedSideMenu.pageDropdownNavbar = {placeholder: 'Select page...', label:'Page',name:'pages', selectedItem:this.selectedSideMenu.TargetPage ,
                   paddingLeft:true,hideLabel:false,sizeXs:false,dropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'};
                 
                   this.selectedSideMenu.taskDropdownNavbar = {placeholder: 'Select task...', label:'Task',name:'tasks', selectedItem: this.selectedSideMenu.TargetTask,
                   paddingLeft:true,hideLabel:false,sizeXs:false,dropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'};
               
                   break;
                }
             }
          }
      }
           
    };
    
  /**********************************************************
	***************** GET NAVBAR BY ID ******************
	***********************************************************/  
    getNavbarById (language,type,appId){
      
     if (type==undefined) type=0;
     if (appId==undefined) appId=0;
     if (this.navbar[language+type+appId]==undefined)
      {
          this.getNavbarsFromMenus(language,type,false,appId);
      }
      
      for (var j=0;j<this.navbar[language+type+appId].length;j++)
      {	  
          if (this.navbar[language+type+appId][j].id == this.currentNavbarId)
          {
            
             this.selectedNavbar=null;
             this.selectedNavbar= this.navbar[language+type][j]
             this.selectedNavbar.headerLabel="Select users/groups that will have access to this navigation bar";
             this.selectedNavbar.usersLabel="Users";
             this.selectedNavbar.groupsLabel="Groups";
             this.selectedNavbar.pageDropdownNavbar = {placeholder:'Select page...',label:'Page',name:'pages',selectedItem: this.selectedNavbar.TargetPage,
                  paddingLeft:true,hideLabel:false,dropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'};
                  
             this.selectedNavbar.menuTypeDropdownNavbar = {placeholder:'Select menu position...',label:'Menu position',name:'Menutypes',selectedItem:this.selectedNavbar.MenuType,
                  paddingLeft:true,hideLabel:false,dropdownSize:'col-lg-16',columnSizeLabel:'col-lg-24'}; 
             
             return  this.selectedNavbar;
            
          }
      }         
     return null;
    };

 
    
  /**********************************************************
	***************** GET SIDEMENU BY ID ******************
	***********************************************************/  
    getSideMenuById (menuId,language,type){
      
      if (type==undefined) type=0;
      for (var j=0;j<this.sidemenus[language+type].length;j++)
      {	  
          if (this.sidemenus[language+type][j].id == menuId)
          {
           return this.sidemenus[language+type][j];
            
          }
      }         
     return null;
    };    
	/**********************************************************
	***************** GET NAVBAR ******************
	***********************************************************/     
  
 getNavbar (language){
          
          
              var deferred = this.$q.defer();                   
             
              if (this.navbar[language]==undefined){
				  //if  not found - download
			
      
			$http({
                method: 'GET',
                url: '../api/get-navbar/'+language+'/',
                headers: { 'Content-Type': 'application/json' },

               // data: $scope.resource
             
            })
                .then(function (data) {

                    if (data.status === 200) {
              
                      //var retrivedList = {lang: language, navbar: data};
                      
                      //var pos = menuList.map(function(e) { return e.lang; }).indexOf(language);
                         this.navbar[language] = data.data;
                        
                    
                      
                      deferred.resolve(this.navbar[language]);
                    }
                    else {
                        deferred.reject(data);
                    } 
                    
                },
                function (error) {
                    
                    
                    deferred.reject(error);
                });
				
              } else {
               
                deferred.resolve(this.navbar[language]);
              }
            
            
	
          return deferred.promise;
		  };
		  	/**********************************************************
      ***************** GET NAVBAR BY TARGET NAME ******************
      ***********************************************************/     
  
 getNavbarByTargetName (targetIn,language,type,appId){

       var navbar_id=0;
       var target=null;
       
       if (type==undefined) type=0;
       if (appId==undefined) appId=0;
       if (this.editMode) type=1;
       if (this.menuList[language+type+appId]==undefined) return 0;
       for (var i=0;i<this.menuList[language+type+appId].length;i++)
       {
        if (this.menuList[language+type+appId][i].MenuType==1)
        {
          if (this.menuList[language+type+appId][i].TargetPage!=undefined && this.menuList[language+type+appId][i].TargetPage!=null)
          {
            target=this.menuList[language+type+appId][i].TargetPage.Target;
          }
        }
        else
        {
           if (this.menuList[language+type+appId][i].TargetTask!=undefined && this.menuList[language+type+appId][i].TargetTask!=null)
          {
            target=this.menuList[language+type+appId][i].TargetTask.Target;
          }
        }
          if (target!=null)
          {
             if (target==targetIn)
             {
             navbar_id =  this.menuList[language+type+appId][i].Navbar;
             break;
             }
          }
        }
      return navbar_id;
    };
   /**********************************************************
	***************** FUNCTIONS NOT USED !!!!!!!!!!!! ******************
	***************** ************************************************** 
   ***********************************************************
   ***********************************************************
   ***********************************************************
	***********************************************************/
   
  /**********************************************************
	***************** GET MENUS FOR PAGE ******************
	***********************************************************/     
  
 getMenusForPage (pageid,language){
          
          if (page != undefined) {
              var deferred = this.$q.defer();                   
              
              if (this.menuList[page+language]==undefined){
				  //if  not found - download
			
      
			$http({
                method: 'GET',
                url: '../api/get-menus-for-page/'+ page+'/'+language+'/',
                headers: { 'Content-Type': 'application/json' },

               // data: $scope.resource
             
            })
                .then(function (data, status) {

                    if (status === 200) {
                      
                      
                      for (var i=0;i<data.length;i++)
                       {
                        this.menuList[data[i].Target+language]=data[i];
                        
                       }
                      if (this.menuList[page+language]!=undefined)
                        deferred.resolve(this.menuList[page+language].Menus, status);
                      else
                        deferred.resolve([], status);
                    } else {
                        deferred.reject(data, status);
                    }
                },
                function (data, status) {
                    
                    console.log("ERROR!!!-"+status);
                    deferred.reject(data, status);
                });
				
              } else {
                deferred.resolve(this.menuList[page+language].Menus, 200);
              }
            };
	
          return deferred.promise;
		  };
		  
	/**********************************************************
	***************** GET MENUS FOR USER ******************
	***********************************************************/     
  
 getMenusForUser (page,language){
          
          var menuIndex=-1;
          if (page != undefined) {
              
              var deferred = this.$q.defer();                   
              var posLang = menuList.map(function(e) { return e.lang; }).indexOf(language);
              if (posLang<0){
				  //if  not found - download
			
      
			$http({
                method: 'GET',
                url: '../api/get-menus-for-page/'+ page+'/'+language+'/',
                headers: { 'Content-Type': 'application/json' },

               // data: $scope.resource
             
            })
                .then(function (data) {

                    if (data.status === 200) {
              
                      var retrivedList = {lang: language, menuList: data.data};
                      
                      //var pos = menuList.map(function(e) { return e.lang; }).indexOf(language);
                       
                      if (posLang>=0)
                      {
                        this.menuList[posLang].menuList= data.data;
                        menuIndex=posLang;
                      }else
                      {
                        
                        menuList.push(retrivedList);
                        menuIndex=menuList.length-1;
                      }
                      
                      deferred.resolve(this.menuList[menuIndex].menuList);
                      
                    } else {
                        deferred.reject(data);
                    }
                },function (error) {
                    
                   
                    deferred.reject(error);
                });
				
              } else {
                menuIndex=posLang;
                deferred.resolve(this.menuList[menuIndex].menuList);
              }
            };
	
          return deferred.promise;
		  };
		  
	/**********************************************************
	***************** GET PAGES FOR USER ***********************
	***********************************************************/     
  
 getPagesForUser (language){
          
             
              var deferred = this.$q.defer();
              var instance = this;
              if (angular.equals(this.pageList,{})){
				  //if  not found - download
			
      
			this.$http({
                method: 'GET',
                url: '../api/get-pages-for-user/'+language+'/',
                headers: { 'Content-Type': 'application/json' },

               // data: $scope.resource
             
            })
                .then(function (data) {

                    if (data.status === 200) {
              
                     // var retrivedList = {lang: language, pageList: data};
                        for (var i=0;i<data.data.length;i++)
                       {
                        instance.pageList[data.data[i].id+language]=data.data[i];
                        
                       }
                      
                        deferred.resolve(instance.pageList);
                       
                      
                    } else {
                        deferred.reject(data.data);
                    }
                },function (error) {
                    
                    //console.log("ERROR!!!-"+status);
                    deferred.reject(error);
                });
				
              } else {
                deferred.resolve(instance.pageList);
              }
          
	
          return deferred.promise;
		  };
	
  		/**********************************************************
	***************** GET NAVBARS FROM PAGE LIST ******************
	***********************************************************/  
    getNavbarsFromPageList (language){
      
      if (this.navbar[language]==undefined){
        this.navbar[language] = [];
       this.sidemenus[language] = []
       var pos=-1;
     for (var key in this.pageList) {
      
       for (var i=0;i<this.pageList[key].Menus.length;i++)
       {
          if (this.pageList[key].Menus[i].MenuPosition.id.substr(0,6)=="navbar")
          {
          
            pos =this.navbar[language].map(function(e) { return e.id; }).indexOf(this.pageList[key].Menus[i].id);
            if (pos<0) this.navbar[language].push(this.pageList[key].Menus[i]);
          
         }else if (this.pageList[key].Menus[i].MenuPosition.id=="sidemenu")
         {
          
             pos =this.sidemenus[language].map(function(e) { return e.id; }).indexOf(this.pageList[key].Menus[i].id);
             if (pos<0) this.sidemenus[language].push(this.pageList[key].Menus[i]);
          
        
          }
           
        }
      
      }
      
      //get Menus
      
    for (var j=0;j<this.navbar[language].length;j++)
    {
         for (var k=0;k<this.sidemenus[language].length;k++)
       {
        if (this.navbar[language][j].id==this.sidemenus[language][k].Navbar)
        {
          if (this.navbar[language][j].SideMenus ==undefined) this.navbar[language][j].SideMenus = [];
          
          pos =this.navbar[language][j].SideMenus.map(function(e) { return e.id; }).indexOf(this.sidemenus[language][k].id);
          if (pos<0) this.navbar[language][j].SideMenus.push(this.sidemenus[language][k]);
          
        }
       }
    }
      
 }
      return this.navbar[language];
};

 
	/**********************************************************
	***************** GET MENUS FOR PAGE BY ID ******************
	***********************************************************/     
  
 getMenusForPageById (pageid,language){
          
          if (pageid != undefined) {
           
              
              if (this.pageList[pageid+language]!=undefined){
				  

                return this.pageList[pageid+language].Menus;
             
            }else{
              return null ;
            }
          }
	
         
		  };
	
 	/**********************************************************
	***************** GET PAGE NAVBAR ******************
	***********************************************************/     
  
 getPageNavbar (pageid,language){
      
      if (this.pageList[pageid+language]!=undefined)  return this.pageList[pageid+language].Navbar;
      else {
       
         return null;
      }
           
		  };
      
 	/**********************************************************
	***************** GET PAGE NAVBAR BY NAME ******************
	***********************************************************/     
  
   getPageNavbarByName (pagename,language){
      
      var navbar=0;
      for (var key in this.pageList) {
       
      if (this.pageList[key].Target==pagename)  navbar =  this.pageList[key].Navbar;
     
           
		}
      return navbar;
    };  
   
}

export {MenuService};

class ClearService{
   constructor(MenuService)
   {
      this.MenuService=MenuService;
   }
   static $inject = ['MenuService'];
 

 
    Clear()
    {
      this.MenuService.Clear();
    }

 };
 export {ClearService};